import type { AnswerType } from '../../lib/quizData';
import styles from './MatchedItem.module.css';

interface Props {
  index: number;
  text: string;
  tag: string;
  p1Answer: AnswerType;
  p2Answer: AnswerType;
}

const EMOJI: Record<AnswerType, string> = {
  Yes: '👍',
  Maybe: '😏',
  No: '',
};

export function MatchedItem({ index, text, tag, p1Answer, p2Answer }: Props) {
  return (
    <div className={styles.item}>
      <div className={styles.num}>{index + 1}</div>
      <div className={styles.content}>
        <span className={styles.tag}>{tag}</span>
        <p className={styles.text}>{text}</p>
        <div className={styles.badges}>
          <span className={styles.badge}>{EMOJI[p1Answer]} Her</span>
          <span className={styles.badge}>{EMOJI[p2Answer]} Him</span>
        </div>
      </div>
    </div>
  );
}
